export default __webpack_public_path__ + "static/media/Policies.4bdaaac9.svg";